'use strict'
import { request } from '../../plugins/http'

export default async (params, data) => {
    console.log(data)
    return await request.post('/file', data, {params:params}, {headers:{"Content-Type": "multipart/form-data"}})
}